const API_URL = "/api/partizi";

export const esalonariApi = {
  // 1. Obține eșalonările
  get: async (partidaId) => {
    const res = await fetch(`${API_URL}/esalonari/${partidaId}`);
    if (!res.ok) throw new Error("Eroare la preluarea eșalonărilor");
    return res.json();
  },

  // 2. Salvează eșalonarea (Luna)
  save: async (datePayload) => {
    const res = await fetch(`${API_URL}/esalonari`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(datePayload),
    });
    if (!res.ok) throw new Error("Eroare la salvarea eșalonării");
    return res.json();
  },

  // 3. ȘTERGERE EȘALONARE (Aceasta lipsea și dădea eroare la butonul de ștergere lună)
  delete: async (id) => {
    const res = await fetch(`${API_URL}/esalonari/${id}`, {
      method: "DELETE",
    });
    if (!res.ok) throw new Error("Eroare la ștergerea eșalonării");
    return res.json();
  },

  // 4. Salvează realizările (Recepții)
  saveRealizari: async (payload) => {
    // payload conține { dateEsalonare, partidaId }
    const res = await fetch(`${API_URL}/salveaza-realizari`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        // Mapăm datele pentru a se potrivi cu ce așteaptă backend-ul (dateRealizari)
        dateRealizari: payload.dateEsalonare,
        partidaId: payload.partidaId,
      }),
    });

    if (!res.ok) {
      const errorData = await res.json();
      throw new Error(errorData.error || "Eroare la salvarea realizărilor");
    }
    return res.json();
  },

  // 5. Șterge o recepție din istoric
  deleteReceptie: async (esalonareId, receptie) => {
    const res = await fetch(`${API_URL}/receptie/${esalonareId}`, {
      method: "DELETE",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(receptie),
    });
    if (!res.ok) throw new Error("Eroare la ștergerea recepției");
    return res.json();
  },
};
